const appAnalysis = () =>
  import ('@/app/views/analysis');
const appRecords = () =>
  import ('@/app/views/records');
const appFeedback = () =>
  import ('@/app/views/feedback');
const resetPassEmail = () =>
  import ('@/app/views/resetPassEmail.vue');
const aboutUs = () =>
  import ('@/app/views/aboutUs.vue');
const help = () =>
  import ('@/app/views/help.vue');
const merchantAgreement = () =>
  import ('@/app/views/merchantAgreement.vue');
const userAgreement = () =>
  import ('@/app/views/userAgreement.vue');
const dataAnalysis = () =>
  import ('@/app/views/raffle/dataAnalysis.vue');
const raffleRecords = () =>
  import ('@/app/views/raffle/records.vue');
const raffleHome = () =>
  import ('@/app/views/raffle/index.vue');
const customerFlow = () =>
  import ('@/app/views/customerFlow');

var VUE = null

export default (Router, Store, Vue) => {
  VUE = Vue
  return new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    scrollBehavior: () => ({
      y: 1
    }),
    routes: [{
      path: '/app/analysis',
      name: 'appAnalysis',
      component: appAnalysis
    }, {
      path: '/app/records',
      name: 'appRecords',
      component: appRecords
    }, {
      path: '/app/feedback',
      name: 'appFeedback',
      component: appFeedback
    }, {
      path: '/app/reset-password',
      name: 'resetPass',
      component: resetPassEmail
    }, {
      path: '/app/aboutus',
      name: 'aboutUs',
      component: aboutUs
    }, {
      path: '/app/help',
      name: 'help',
      component: help
    }, {
      path: '/app/agreement/admission',
      name: 'merchantAgreement',
      component: merchantAgreement
    }, {
      path: '/app/agreement/user',
      name: 'userAgreement',
      component: userAgreement
    }, {
      path: '/app/raffle/data-analysis',
      name: 'dataAnalysis',
      component: dataAnalysis
    }, {
      path: '/app/raffle/records',
      name: 'records',
      component: raffleRecords
    }, {
      path: '/app/raffle',
      name: 'records',
      component: raffleHome
    },{
      path: '/app/customer-flow',
      name: 'customer-flow',
      component: customerFlow
    },]
  })
}



// WEBPACK FOOTER //
// ./src/router/app/index.js